var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{class:[_vm.data.staticClass, _vm.data.class],attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.data.props.size,"height":_vm.data.props.size,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M7 14l5-5 5 5z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }